exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "details summary .fa-angle-double-down:before {\n    content: \"\\F055\";\n}\ndetails[open] summary .fa-angle-double-down:before {\n    content: \"\\F056\";\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/clients/overview/clients-overview.component.css
// module id = 1941
// module chunks = 0